  <template>
    <v-navigation-drawer
    v-model="show"
    app
    right
    color="accent"
    >
        <v-list
        flat
        >

            <v-list-item>
                <v-list-item-content class="pb-0">
                    <v-autocomplete
                        v-model="system"
                        :items="systems"
                        item-text="title"
                        item-value="id"
                        outlined
                        chips
                        small-chips
                        label="System"
                        multiple
                        clearable
                        dark
                    ></v-autocomplete>
                </v-list-item-content>
            </v-list-item>
            <v-list-item >
                <v-list-item-content class="pb-0">
                    <v-autocomplete
                        v-model="user"
                        :items="users"
                        item-text="name"
                        item-value="id"
                        outlined
                        chips
                        small-chips
                        label="Employee"
                        multiple
                        clearable
                        dark
                    ></v-autocomplete>
                </v-list-item-content>
            </v-list-item>
            <v-list-item >
                <v-list-item-content class="pb-0">
                    <v-autocomplete
                        v-model="status"
                        :items="statuses"
                        item-text="title"
                        item-value="id"
                        outlined
                        chips
                        small-chips
                        label="Status"
                        multiple
                        clearable
                        dark
                    ></v-autocomplete>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        >
        <v-subheader class="mt-3 white--text">Search by Date</v-subheader>
            <v-list-item>
                <v-list-item-content class="pb-0">
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRangeText"
                            label="Date Range"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            clearable
                            dark
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="dates" no-title scrollable range>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="rangeCancel">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>   
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="pb-0">      
                    <v-btn
                        depressed 
                        tile
                        large
                        color="primary"
                        class="mx-0 mb-0 mt-0"
                        @click.prevent="submitSearch">
                    
                        <v-icon>mdi-magnify</v-icon>
                        Search
                    </v-btn>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['show', 'filter', 'routekey'],
  data: () => ({
    menu: false,
    id: "",
    system: [],
    user: [],
    dates: [],
    status: []
  }),
  computed: {
        ...mapGetters({
            users: 'data/users',
            systems: 'data/systems',
            statuses: 'data/task_status'
        }),
        dateRangeText () {
          if(this.dates.length == 2) {
            if(this.dates[0] > this.dates[1]) {
                return this.dates[1] + '/' + this.dates[0]
            } else {
                return this.dates[0] + '/' + this.dates[1] 
            }
          } else {
              return this.dates[0]
          }
      },
  },
  created() {
      this.id = this.filter.id
      this.system = this.filter.system
      this.user = this.filter.user
      this.status = this.filter.status
  },
  watch: {
    show(newVal) { // watch it
        this.$emit('update-drawer', newVal)
    },
    id(newVal) {
        this.$emit('update-id', newVal)
    },
    user(newVal) {
        this.$emit('update-user', newVal)
    },
    system(newVal) {
        this.$emit('update-system', newVal)
    },
    status(newVal) {
        this.$emit('update-status', newVal)
    },
    dateRangeText(newVal) {
        this.$emit('update-daterange', newVal)
    },
  },
  methods: {
    submitSearch() {
        this.$emit('submit-search')
    },
    rangeCancel() {
        this.menu = false
        this.dates = []
    }
  }
}
</script>